export const days = [
  'Daily',
  'Weekdays',
  'Weekends',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const units = [{ name: 'square feet', label: 'Square feet' }];

export const SPACE_CATEGORY = {
  WORK: 'Work',
  MEETING: 'Meeting Space',
  TRAIN: 'Train',
  SHOOT: 'Shoot'
};

export const SPACE_PAYMENT_OPTIONS = {
  HOURLY: 'Hourly',
  DAILY: 'Daily',
  BLOCK: 'Block',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
};
export const SPACE_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  PENDING:'PENDING',
  DECLINED:'DECLINED'
};

export const SPACE_ACTIVITIES = {
  HOT_DESK: 'WORK_HOTD',
  PRIVATE_OFFICE:'Private Office'
};

export const COUNTRY_CODES = [
  { code: '+94', name: 'LK', label: 'Sri Lanka', lat: 7.8731, lng: 80.7718 },
  // { code: '+65',name: 'SG', label: 'Singapore', lat: 1.290270, lng: 103.851959},
  // { code: '+61', name: 'AUS', label: 'Australia', lat: -37.971237, lng: 144.4926947 }
];
export const BOOKING_TYPE = [
  { name: 'Instant Booking', boolValue: true },
  { name: 'Request to book' , boolValue: false }
];

// Booking Types from backend (BookingType.java enum)
export const BOOKING_TYPES = {
  SYSTEM_BOOKING: 'SYSTEM_BOOKING',           // MillionSpaces - Online bookings
  MANUAL_BOOKING: 'MANUAL_BOOKING',           // Blocked by host - Manual reservations
  OFFLINE_BOOKING: 'OFFLINE_BOOKING',         // Offline Admin Booking
  GOOGLE_CALENDAR_EVENT: 'GOOGLE_CALENDAR_EVENT' // Google calendar synced events
};

// Platform display names for booking types
export const PLATFORM_NAMES = {
  [BOOKING_TYPES.SYSTEM_BOOKING]: 'MillionSpaces',
  [BOOKING_TYPES.MANUAL_BOOKING]: 'Blocked by host',
  [BOOKING_TYPES.OFFLINE_BOOKING]: 'Offline Admin Booking',
  [BOOKING_TYPES.GOOGLE_CALENDAR_EVENT]: 'Google Calendar'
};

export const POPUP_STATUS = {
  ACTIVATE: 'Activate',
  DEACTIVATE: 'Deactivate',
  APPROVE:'Approve',
  REJECT:'Reject'
}

export const SELECTON_TYPE = [
    {name:"Yes",value: true},
    {name:"No",value: false}
];
